import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import ReportIcon from '@mui/icons-material/Report';
import sty from './ChecklistModal.module.css';

function ChecklistAssignedPatrolWarning({ handler, numberOfAssignedPatrols }) {
	const {
		onProceedToSave = null,
		onCancel = null,
		onMoreInfo = null,
	} = handler || {};
	return (
		<Dialog
			open={true}
			onClose={onCancel}
			aria-labelledby="draggable-dialog-title"
		>
			<div className={sty.header_bar} />
			<section className={sty.dialog_section}>
				<ReportIcon className={sty.icon} />
				<div className={sty.dialog_title_content}>
					<DialogTitle
						className={sty.dialog_title}
						id="draggable-dialog-title"
					>
						Warning: Checklist assigned to patrols
					</DialogTitle>
					<DialogContent className={sty.dialog_content}>
						<DialogContentText>
							This checklist is assigned to{' '}
							{numberOfAssignedPatrols} upcoming patrol(s). If you
							make changes to this checklist, the changes will be
							reflected in the patrol's checklist. Do you want to
							continue?
						</DialogContentText>
						<Button onClick={onMoreInfo}>More Info</Button>
					</DialogContent>
				</div>
			</section>
			<Divider />
			<DialogActions className={sty.dialog_actions}>
				<Button variant="outlined" size="small" onClick={onCancel}>
					Cancel
				</Button>
				<Button
					variant="contained"
					size="small"
					onClick={onProceedToSave}
				>
					Proceed
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default ChecklistAssignedPatrolWarning;
